<template>
  <div class="item_content">
    <div class="pricture_name">
      {{ ProductItem.Name }}
    </div>
    <div class="item_content_area">
      <van-image
        class="item_picture"
        fit="contain"
        :src="ProductItem.CompleteImages"
      />

      <div class="item_price_cart">
        <div class="item_price_cart_bottom">
          <div class="item_price">{{ ProductItem.PriceFormat }}</div>
          <div>
            <van-button
              @click="GetProduct()"
              icon="plus"
              size="mini"
              type="primary"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <van-action-sheet v-model:show="AttributeShow" title="属性">
    <div class="attribute_content">
      <div v-for="(item, index) in Product.Groups" :key="index">
        <AttributeGroupModule
          :AttributeGroup="item"
          v-model="item.ProductAttributeOpt"
        />
      </div>

      <van-cell
        :title="tools.GetLanguageValue('public.app.要求')"
        v-if="
          Product.ProductRemarkFree.length > 0 ||
          Product.ProductRemarkCollectFree.length > 0
        "
      />

      <van-checkbox-group v-model="ProductRemarkOpts" direction="horizontal">
        <div
          v-for="item in Product.ProductRemarkFree"
          :key="item.Id"
          class="product_remark"
        >
          <van-checkbox icon-size="13" shape="square" :name="item">
            {{ item.Name + item.PriceFormat }}</van-checkbox
          >
        </div>
        <div
          v-for="item in Product.ProductRemarkCollectFree"
          :key="item.Id"
          class="product_remark"
        >
          <van-checkbox  icon-size="13"  shape="square" :name="item">
            {{ item.Name + item.PriceFormat }}</van-checkbox
          >
        </div>
      </van-checkbox-group>

      <br />
      <br />
      <br />
      <br />
      <van-button type="primary" @click="AddShoppingCart()" block
        > {{tools.GetLanguageValue('public.app.加入购物车')}}</van-button
      >
    </div>
  </van-action-sheet>
</template>
<script >
import axios from "../../commons/AxiosMethod.js"
import AttributeGroupModule from "../../components/AttributeGroupModule.vue"
import tools from "../../commons/tools.js"
import { showToast } from "vant"
export default {
  data () {
    return {
      productImg: require("../../assets/正方形logo.png"),
      index: 0,
      tools: tools,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      Product: {}, // 商品
      AttributeShow: false, // 显示属性面板
      ProductAttributeOpt: [], // 选中属性
      ProductRemarkOpts: [] // 选中备注
    }
  },
  name: "App",
  props: {
    ProductItem: {}
    // ProductRemarkOpts: [], //选中的要求
  },
  mounted () {
    this.Product = this.ProductItem
    this.ProductRemarkOpts = []
  },
  components: {
    AttributeGroupModule
  },
  methods: {
    // 获取商品
    GetProduct () {
      const param = { Id: this.ProductItem.Id }
      axios.apiMethod(
        "/Shopping/Product/GetProduct",
        "get",
        param,
        (result) => {
          if (result.Code == 200) {
            this.Product = result.Data
            if (
              result.Data.Groups.length > 0 ||
              result.Data.ProductRemarkCollectFree.length > 0 ||
              result.Data.ProductRemarkFree.length > 0
            ) {
              this.AttributeShow = true
            } else {
              this.AddShoppingCart()
            }
          } else {
            showToast(result.FullMsg)
          }
        }
      )
    },
    // 添加购物车
    AddShoppingCart () {
      const param = {
        ProductId: this.Product.Id,
        Count: 1,
        Remarks: this.Product.Remarks,
        OptProductRemarkItems: this.ProductRemarkOpts,
        ProductAttributeGroups: this.Product.Groups
      }
      this.ProductRemarkOpts = []

      axios.apiMethod(
        "/TakeOuts/ShoppingTrolley/AddShoppingCart",
        "post",
        param,
        (result) => {
          if (result.Code == 200) {
            showToast(result.Data.Msg)
            this.ProductRemarkOpts = []
            this.AttributeShow = false
          } else {
            showToast(result.FullMsg)
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.product_remark {
  padding: 5px;
  font-size: 7pt;
}
.item_content {
  max-width: 100%;
  height: 160px;
  border-top: 1px solid rgb(67, 65, 65);
  background-color: rgb(248, 248, 248);
  padding: 10px;

  .pricture_name {
    margin-top: 10px;
    color: #333;
    font-size: 11pt;
    width: 80%;
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    font-family: "YouYuan";
    font-weight: 500;
  }
  .item_content_area {
    margin: 0 auto;
    margin-top: 10px;
    width: calc(100% - 20px);
    height: 100px;
    border-radius: 5px;
    display: flex;
    border-bottom: 1px dashed rgb(166, 163, 163);
    .item_picture {
      background-color: #fff;
      width: 125px;
      height: 80px;
    }
    .item_price_cart {
      margin: 0 auto;
      font-size: 9pt;
      width: calc(100% - 130px);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;
      .item_price_cart_bottom {
        position: absolute;
        height: 40px;
        bottom: 0px;
        right: 0px;
        line-height: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .item_price {
          width: 100px;
          line-height: 40px;
          color: #333;
          font-family: "Titillium Web", Arial, sans-serif;
          font-size: 13pt;
        }
      }
    }
  }
  .item_content_chengfen {
    height: 20px;
    display: flex;
    .items {
      width: 20px;
      height: 20px;
      border: 1px solid #333;
      margin-left: 5px;
      text-align: center;
    }
  }
}
.attribute_content {
  overflow: auto;
}
</style>
